import { render } from "./DesignView.vue?vue&type=template&id=43ef277e"
import script from "./DesignView.vue?vue&type=script&lang=js"
export * from "./DesignView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__